<template>
    <div class="flex flex-col" :class="[isForm ? 'complaint-form-group' : 'space-y-0.5' ]">
      	<div class="flex justify-between items-center">
          <label class="form-label" :class="currentError ? 'form-error' : ''" :for="id">{{ label }}<sup v-if="required">*</sup></label>
				  <p class="text-xs text-gray-500" v-if="!required">Opcional</p>
			  </div>
      <input
        :id="id"
        v-model="inputValue"
        :type="type"
        :class="[
          'w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 placeholder:font-light',
          isForm
            ? (currentError ? 'border-red-500' : 'border-gray-300')
            : (currentError ? 'border-red-500' : 'border-gray-800'),
          isForm
            ? 'border rounded-md p-2 text-gray-500 placeholder:text-gray-300 mt-1'
            : 'form-input p-2 placeholder:text-gray-400 text-gray-600 placeholder:italic'
        ]"
        :placeholder="placeholder"
        @blur="validateInput(); $emit('blur')"
        @focus="$emit('focus')"
      />
      <span :class="currentError ? 'h-4 opacity-100' : 'opacity-0'" class="text-sm text-red-500">{{ currentError }}</span>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'wm-input',
    props: {
        type: {
            type: String,
            default: 'text'
        },
        label: {
            type: String,
            default: 'Input Label'
        },
        errorMessage: {
            type: String,
            default: ''
        },
		  placeholder: {
				type: String,
				default: 'Ingresa el valor'
		  },
		  required: {
				type: Boolean,
				default: false
		  },
        id: {
            type: String,
            default: 'inputField'
        },
		  modelValue: {
				type: String,
				default: ''
		  },
        isForm: false,
    },
    watch: {
      modelValue: function (newValue) {
            this.validateInput();
        }
    },
	 emits: ['update:modelValue', 'focus', 'blur'],
	 computed: {
		// Implement v-model for inputs
		// https://vuejs.org/guide/components/v-model.html
    inputValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  	},
    data() {
        return {
				currentError: '',
        };
    },
    methods: {
        validateInput() {
            if (!this.inputValue && this.required) {
                this.currentError = this.errorMessage || 'Campo requerido';
            } else {
                this.currentError = '';
            }
        },
    }
});
</script>

<style lang="css" scoped>

@reference "tailwindcss";

.form-error{
  @apply text-red-500;
}
</style>
